/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The current status of the subscription.
 */
export const SubscriptionStatus = {
  Active: "active",
  Canceled: "canceled",
  Unpaid: "unpaid",
  Paused: "paused",
  Trialing: "trialing",
  ScheduledCancel: "scheduled_cancel",
} as const;
/**
 * The current status of the subscription.
 */
export type SubscriptionStatus = ClosedEnum<typeof SubscriptionStatus>;

/** @internal */
export const SubscriptionStatus$inboundSchema: z.ZodNativeEnum<
  typeof SubscriptionStatus
> = z.nativeEnum(SubscriptionStatus);
/** @internal */
export const SubscriptionStatus$outboundSchema: z.ZodNativeEnum<
  typeof SubscriptionStatus
> = SubscriptionStatus$inboundSchema;
